// src/components/Footer.jsx
export default function Footer() {
  return (
    <footer style={styles.footer}>
      <div style={styles.inner}>
        <span style={styles.logo}>
          <img src="/myicon.png" alt="CaféPantry Logo" style={styles.logoImg} />
          CaféPantry
        </span>
        <span style={styles.tagline}>Cook with love. Share with joy.</span>
        <span style={styles.copy}>© 2025 CaféPantry</span>
      </div>
    </footer>
  );
}

const styles = {
  footer: {
    background: "#f0e8d8",
    borderTop: "1.5px solid #e0cdb0",
    marginTop: "4rem",
  },
  logoImg: {
  width: "24px",
  height: "24px",
  marginRight: "8px",
  verticalAlign: "middle"
},
  inner: {
    maxWidth: "1100px",
    margin: "0 auto",
    padding: "1.5rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: "0.5rem",
  },
  logo: {
    fontFamily: "'Playfair Display', serif",
    fontSize: "1.1rem",
    color: "#6b4f2e",
    fontWeight: 600,
  },
  tagline: {
    color: "#9b7b54",
    fontStyle: "italic",
    fontSize: "0.9rem",
  },
  copy: {
    color: "#c4a882",
    fontSize: "0.82rem",
  },
};
